import Vue from 'vue';
import HeroSection from '@/components/HeroSection/HeroSection.vue';
import PageNav from '@/components/page-nav/PageNav.vue';
var UbLogo = require("@/assets/svgs/ub-logo.svg");
export default Vue.extend({
    name: 'PageNotFound',
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'Hoppala 404',
        // all titles will be injected into this template
        titleTemplate: '%s | Ultrabold Kommunikationsdesign GmbH'
    },
    components: {
        'hero-section': HeroSection,
        'page-nav': PageNav,
        'ub-logo': UbLogo,
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Errors/PageNotFound/PageNotFound.vue
// module id = null
// module chunks = 